<!-- event Head -->
<div class="loader_session" *ngIf='loaderdata'>
  <div class="loader-4"><span></span>
</div>
</div>

<div
  class="event-header"
  style="background-image: url(assets/image/Group-1895.png)"
>
  <div class="event-heading">
    <div class="event-head">
      <h3>MY ACCOUNT</h3>
    
    </div>
  </div>
</div>

<div class="container" >
  <div class="nav-user">
    <div class="row">
      <div class="col-md">
        <div  [className]="isActiveProfil ? 'active pro-list' : 'pro-list'" class="pro-list" (click)="check('profile')">
        <p >Profile</p>
        </div>
      </div>
      <div class="col-md">
        <div   [className]="isActivesub ? 'active pro-list' : 'pro-list'" (click)="check('subscription')">
        <p >Subscription</p>
        </div>
       
      </div>
      <div class="col-md" *ngIf="directoryaccess">
        <div   [className]="isActiveMember ? 'active pro-list' : 'pro-list'" (click)="check('memberlist')">
        <p >Members</p>
        </div>
       
      </div>
    </div>
  </div>

  <div class="details">
    <ng-template [ngIf]="profileview == 'profile'">
         <app-userdetails></app-userdetails>
   
    </ng-template>
    <ng-template [ngIf]="profileview == 'subscription'">
      <app-subscription></app-subscription>
          </ng-template>
          <ng-template [ngIf]="profileview == 'memberlist'">
            <app-memberdirectory></app-memberdirectory>
          </ng-template>

      

   

 
  </div>
   

</div>